<template>
  <VView class="rules" back-button-to="/menu" header="Zasady">
    <VText small>Lubisz spędzać czas z Przyjaciółmi? Pokaż nam, jak!</VText>
    <VText center>Co trzeba zrobić?</VText>
    <VText small>1. Zrób zdjęcie, które pokazuje, gdzie i jak oglądasz Przyjaciół. Zdjęcie może być dowolne, liczymy na Twoją kreatywność, jedyny wymóg to widoczny ekran z serialem Friends na kanale Comedy Central.</VText>
    <VText small>2. Wyślij zdjęcie przez formularz na tej stronie.</VText>
    <VText center>Zasady:</VText>
    <VText small> - Zdjęcie musi być Twojego autorstwa i przedstawiać moment oglądania Przyjaciół.</VText>
    <VText small> - Możesz wysłać tylko jedno zdjęcie.</VText>
   <VText center>Konkurs trwa od  16.09 do 30.09.2024 r. <br />Szczegóły znajdziesz w <a href="regulamin.pdf" target="_blank">regulaminie</a>.</VText>

    <!-- <VBlock max-width="460px">
      <transition name="bounceUp" appear>
        <VButton to="/contest">Weź udział!</VButton>
      </transition>
    </VBlock> -->
    <!-- <div class="rules__list">
      <transition name="bounceLeft" appear><VText center v-html="$t('rules.content.0')" /></transition>
      <transition name="bounceRight" appear><VText center v-html="$t('rules.content.1')" /></transition>
      <transition name="bounceLeft" appear><VText center v-html="$t('rules.content.2')" /></transition>
      <transition name="bounceUp" appear><VText center v-html="$t('rules.content.3')" /></transition>
    </div> -->
  </VView>
</template>

<script>
export default {
  name: 'Rules',
};
</script>

<style lang="scss" scoped>
.rules {
}
</style>
